import React from "react";
import axios from "axios";
import { Formik } from "formik";
import { Div, Text, Input } from "atomize";
import InnerHTML from "../../utilities/innerHtml";

import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import PrimaryButton from "../common/PrimaryButton";
import { sendMeGuideValidator } from "../../validators";
import ImageLink from "../common/ImageLink";
import { IsValidUrl, updateActiveCampaignForm } from "../../utilities/helpers";

class ResourcesGuide extends React.Component {
  formikProps;

  /**
   * on submit form
   */
  onSubmit = values => {
    axios
      .post("/api/send-me-guide", values)
      .then(() => {
        this.formikProps.setSubmitting(false);
        this.formikProps.resetForm();
        this.formikProps.setStatus({
          successMessage: "Submitted!",
          errorMessage: null,
        });
      })
      .catch(error => {
        this.formikProps.setSubmitting(false);
        this.formikProps.setStatus({
          successMessage: null,
          errorMessage: "Something went wrong",
        });
      });
  };

  render() {
    const { page, form } = this.props;

    return (
      <Formik
        ref={form => {
          this.formRef = form;
        }}
        initialValues={{
          email: "",
        }}
        onSubmit={this.onSubmit}
        validationSchema={sendMeGuideValidator}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            status,
            setFieldValue,
            isSubmitting,
            handleChange,
            handleBlur,
            submitCount,
            handleSubmit,
          } = props;

          this.formikProps = props;

          return (
            <Div>
              <WebsiteContainer>
                <CustomContainer p={{ x: { xs: "0", sm: "2.5rem" } }}>
                  <Div bg="primary" p="1.75rem 2rem 2rem">
                    <Div
                      d="flex"
                      flexDir={{ xs: "column", md: "row" }}
                      align="center"
                      maxW="47.5rem"
                      m="0 auto"
                    >
                      <Div>
                        <ImageLink
                          link={page.sendMeGuideImage.file.description}
                        >
                          <Div
                            w="15.25rem"
                            bgImg={page.sendMeGuideImage.file.url}
                            bgSize="cover"
                            bgPos="center"
                            p={{ b: "59.2%" }}
                          ></Div>
                        </ImageLink>
                      </Div>
                      <Div flexGrow="1">
                        <Div p={{ l: { md: "2.25rem" } }} w="100%">
                          <Text
                            textSize="subheader4"
                            textWeight="700"
                            textColor="black"
                            maxW="22.5rem"
                            textAlign={{ xs: "center", md: "left" }}
                            m={{ t: { xs: "2rem", md: "0.25rem" } }}
                          >
                            {page.sendMeGuideTitle}
                          </Text>
                          <Div m={{ t: { xs: "2rem", md: "1rem" } }} shadow="3">
                            {typeof window !== "undefined" && (
                              <InnerHTML
                                html={updateActiveCampaignForm(form)}
                              />
                            )}
                            {/* <Input
                              placeholder="yourname@email.com"
                              rounded="xs"
                              fontFamily="secondary"
                              p="0.9rem 1.1rem"
                              h={{ xs: "3rem" }}
                              border="none"
                              suffix={
                                <PrimaryButton
                                  pos="absolute"
                                  bg="black"
                                  hoverBg="black800"
                                  top="0"
                                  right="0"
                                  p="0 1.25rem"
                                  w={{ xs: "7rem", md: "auto" }}
                                  h="100%"
                                  borderColor="black"
                                  rounded={{ r: "xs" }}
                                  textTransform="none"
                                  onClick={handleSubmit}
                                >
                                  Send me the Guide
                                </PrimaryButton>
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              name="email"
                              value={values.email}
                            /> */}
                          </Div>
                        </Div>
                      </Div>
                    </Div>
                  </Div>
                </CustomContainer>
              </WebsiteContainer>
            </Div>
          );
        }}
      </Formik>
    );
  }
}

export default ResourcesGuide;
